import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookCoverBirdieDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 67,
	height: 50,
	viewBox: "0 0 67 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i_3413_281)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M66.2252 18.9498C66.3034 14.47 66.3425 12.2302 65.5006 10.5039C64.76 8.98547 63.5577 7.74046 62.066 6.94732C60.3702 6.04563 58.1303 6.00654 53.6506 5.92834L19.2296 5.32752C15.0526 5.25461 12.9641 5.21816 11.3075 5.97922C9.84883 6.64935 8.6255 7.74279 7.79653 9.11741C6.85508 10.6785 6.65786 12.7581 6.26343 16.9171L4.96972 30.5583C4.52247 35.2743 4.29884 37.6323 5.06863 39.4775C5.74516 41.0991 6.93679 42.4529 8.45946 43.3298C10.192 44.3276 12.5593 44.4051 17.2939 44.56L52.7606 45.7206C57.3008 45.8691 59.5708 45.9434 61.3235 45.1117C62.8648 44.3802 64.1319 43.1751 64.9398 41.6723C65.8584 39.9636 65.8981 37.6927 65.9773 33.1508L66.2252 18.9498Z",
				fill: "white",
				fillOpacity: .16
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.6481 6.07871L19.2266 5.47788C17.1362 5.4414 15.577 5.41372 14.3331 5.49014C13.0911 5.56647 12.1751 5.74576 11.3705 6.11529C9.93923 6.77285 8.73809 7.84642 7.92466 9.19527C7.46755 9.95341 7.18767 10.8432 6.973 12.0687C6.75798 13.2964 6.60989 14.8491 6.41247 16.9308L5.11951 30.5724C4.89564 32.933 4.728 34.6945 4.71249 36.0964C4.69703 37.4965 4.83363 38.5243 5.2073 39.42C5.87115 41.0111 7.04047 42.339 8.53442 43.1994C9.37545 43.6837 10.3772 43.95 11.768 44.1124C13.1605 44.2749 14.929 44.3326 17.2988 44.4101L52.7654 45.5703C55.0377 45.6447 56.7331 45.7002 58.0796 45.6338C59.4244 45.5674 60.4085 45.3801 61.2595 44.9763C62.7718 44.2585 64.0145 43.0756 64.8072 41.6011C65.2533 40.7715 65.4902 39.7984 65.6239 38.4587C65.7578 37.1172 65.7873 35.4211 65.827 33.1479L66.0749 18.947C66.114 16.7047 66.1432 15.0318 66.058 13.7037C65.9729 12.3775 65.7742 11.4082 65.3655 10.57C64.6388 9.08004 63.4589 7.85828 61.9952 7.08001C61.1718 6.64225 60.2101 6.40992 58.8876 6.27858C57.5633 6.14708 55.8904 6.11785 53.6481 6.07871Z",
			stroke: "white",
			strokeOpacity: .16,
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_ddd_3413_281)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 2.68408,
				y: 3.15173,
				width: 59.0754,
				height: 40,
				rx: 8,
				transform: "rotate(-1 2.68408 3.15173)",
				fill: "#434343"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 2.93841,
				y: 3.39733,
				width: 58.5754,
				height: 39.5,
				rx: 7.75,
				transform: "rotate(-1 2.93841 3.39733)",
				stroke: "white",
				strokeOpacity: .08,
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3413_281)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter2_i_3413_281)",
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M38.1443 22.46C38.4425 30.9983 31.7625 38.1618 23.2241 38.46C14.6857 38.7581 7.52225 32.0781 7.22408 23.5397C6.92592 15.0013 13.6059 7.83788 22.1443 7.53971C30.6827 7.24154 37.8462 13.9216 38.1443 22.46Z",
						fill: "url(#paint0_linear_3413_281)"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.167 8.18384C30.3495 7.8982 37.2148 14.3001 37.5006 22.4826C37.7862 30.6651 31.3843 37.5303 23.2018 37.8162C15.0192 38.1019 8.15407 31.6999 7.86823 23.5174C7.58248 15.3348 13.9844 8.46959 22.167 8.18384Z",
					stroke: "black",
					strokeOpacity: .48,
					strokeWidth: 1.28913
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M19.5538 36.6609C20.4499 35.8941 21.3737 35.0223 21.9726 33.9242C22.6547 32.6759 22.8051 31.2882 22.3769 30.212C22.1803 29.7175 21.8826 29.3137 21.4932 29.0112C20.5349 28.2696 19.0874 28.2486 17.7142 28.9559C17.3907 29.122 17.2644 29.5185 17.4308 29.8404C17.5972 30.163 17.9954 30.2882 18.3176 30.1229C19.2175 29.659 20.145 29.6318 20.6838 30.0481C20.8855 30.2049 21.0431 30.4231 21.1524 30.6976C21.439 31.4159 21.3125 32.3866 20.8155 33.2967C20.2169 34.3942 19.1815 35.2613 18.1802 36.0998L18.0445 36.2131C18.0385 36.2181 18.0325 36.2232 18.0265 36.2282C18.524 36.3998 19.0337 36.5446 19.5538 36.6609ZM12.842 33.0708C13.6635 31.5518 14.6115 30.0356 15.6726 28.5441C16.0114 28.0679 16.3808 27.5751 16.8389 26.9889C16.8782 26.9387 16.9805 26.8051 17.0067 26.6032C17.0287 26.4353 16.9857 26.3023 16.9658 26.2406L16.9653 26.2392C16.7117 25.4938 16.6256 24.6696 16.6862 23.5666C16.7286 22.7855 16.8829 22.0492 17.1437 21.3768C17.3506 20.8416 17.7575 20.0965 18.1364 19.7074C18.3681 19.4697 18.3857 19.0965 18.1772 18.8385C17.97 18.5824 17.7416 18.2763 17.6129 17.953L17.5759 17.8646C17.7048 17.9329 17.8097 17.9865 17.8593 18.0062C19.3304 18.5888 20.5308 18.6841 21.757 18.3214C22.1151 18.2146 22.4455 18.1523 22.7123 18.1371C22.968 18.1333 23.2542 18.1626 23.5648 18.2242C23.503 17.9564 23.4659 17.6787 23.4559 17.3937C23.4498 17.2192 23.4541 17.0467 23.4682 16.8768C23.1933 16.8386 22.927 16.8216 22.6665 16.8259C22.2701 16.8475 21.8374 16.927 21.3805 17.0632C20.4584 17.3386 19.5236 17.2516 18.364 16.7947C18.2719 16.7524 17.7082 16.4443 17.4203 16.2651C17.1331 16.0872 16.7586 16.1549 16.552 16.421L16.3998 16.6175C16.383 16.6395 16.3668 16.6628 16.3533 16.6874C15.9453 17.3805 16.1948 17.9739 16.3441 18.3283L16.389 18.4379C16.5049 18.7304 16.6608 18.9942 16.8243 19.231C16.4239 19.773 16.0974 20.4314 15.9145 20.9054C15.604 21.705 15.4219 22.5775 15.3712 23.4968C15.3085 24.6519 15.3898 25.5607 15.6341 26.3956C15.2398 26.9049 14.9079 27.3502 14.5983 27.7843C13.5938 29.1967 12.6872 30.6316 11.8888 32.0718C12.1905 32.4201 12.5086 32.7535 12.842 33.0708ZM29.1744 35.4399C29.4141 34.771 29.5825 34.0799 29.6578 33.3788C29.8728 31.3775 29.2757 29.5887 27.9318 28.2063C27.6789 27.9453 27.2607 27.9398 27.0016 28.192C26.7404 28.4443 26.7341 28.8601 26.987 29.1198C28.0651 30.2292 28.5229 31.6152 28.3488 33.2392C28.239 34.2628 27.8994 35.2646 27.4192 36.195C28.0244 35.9818 28.6105 35.729 29.1744 35.4399ZM25.3726 16.8736C26.4566 16.8357 27.3047 15.9263 27.2668 14.8423L28.1727 14.8107C28.2105 15.8947 29.12 16.7427 30.2039 16.7049L30.2356 17.6107C29.1516 17.6486 28.3035 18.558 28.3414 19.642L27.4355 19.6736C27.3977 18.5896 26.4882 17.7416 25.4043 17.7794L25.3726 16.8736ZM28.7372 21.4922C29.1756 21.3965 29.5884 21.2351 29.9653 21.019C30.4119 22.2235 30.6701 23.8846 30.1578 25.3286C29.8088 26.3135 29.1385 27.0607 28.2204 27.4894C27.8906 27.6427 27.4985 27.5029 27.3448 27.1741C27.1906 26.8452 27.3321 26.4547 27.6612 26.3008C28.2617 26.0203 28.684 25.5458 28.916 24.8914C29.29 23.8375 29.1138 22.5111 28.7372 21.4922ZM24.8718 23.3673C25.5914 23.3421 26.1546 22.7398 26.1295 22.0222C26.1045 21.3045 25.5006 20.7429 24.781 20.7681C24.0614 20.7932 23.4983 21.3955 23.5233 22.1132C23.5484 22.8308 24.1522 23.3924 24.8718 23.3673ZM19.5688 22.2617C19.5437 21.544 20.1069 20.9417 20.8265 20.9166C21.5461 20.8914 22.1499 21.453 22.175 22.1707C22.2001 22.8883 21.6369 23.4906 20.9173 23.5158C20.1977 23.5409 19.5939 22.9793 19.5688 22.2617Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.6495 16.0177L63.6494 16.0002C64.2016 15.9906 64.657 16.4304 64.6667 16.9826L64.7365 20.982C64.7461 21.5342 64.3063 21.9897 63.7541 21.9993L62.7543 22.0168L62.6495 16.0177Z",
			fill: "#FF8637"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.6481 26.6488C55.0793 25.3895 56.5791 22.6015 55.8953 19.633C55.3393 17.2257 53.3245 15.344 50.872 14.895C46.7552 14.1501 43.1542 17.2634 43.2229 21.1962C43.2658 23.655 44.7389 25.7479 46.8399 26.7418L46.8658 28.2253C46.8934 29.8084 48.233 31.0602 49.8201 31.0325C51.4067 31.0048 52.7015 29.707 52.6738 28.1239L52.6481 26.6488ZM47.6061 25.712L49.0964 25.686L49.0411 22.5199L47.6382 21.1607C47.3899 20.9233 47.383 20.5318 47.6228 20.2776C47.8627 20.0317 48.2581 20.0248 48.5064 20.2622L49.6457 21.3657L50.7453 20.2231C50.9851 19.9772 51.3806 19.9703 51.6289 20.2077C51.8774 20.4534 51.8843 20.8449 51.6443 21.0908L50.2909 22.4971L50.3462 25.6641L51.8641 25.6376C53.9428 24.6806 55.2444 22.3733 54.6772 19.9127C54.2367 18.0118 52.6224 16.4814 50.6489 16.1241C47.2886 15.516 44.4181 18.0498 44.4727 21.1744C44.5084 23.2191 45.7874 24.967 47.6061 25.712ZM51.4022 26.8959L51.424 28.1457C51.4393 29.0206 50.7181 29.7666 49.7983 29.7827C48.8772 29.7987 48.1309 29.0783 48.1156 28.2035L48.0938 26.9536L49.6414 26.9266C49.6745 26.9316 49.7087 26.9338 49.7433 26.9332C49.7778 26.9326 49.812 26.9292 49.8449 26.9231L51.4022 26.8959Z",
			fill: "white",
			fillOpacity: .32
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_i_3413_281",
				x: 3.56165,
				y: 5.29138,
				width: 62.7018,
				height: 42.5223,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1,
						dy: 2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_3413_281"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ddd_3413_281",
				x: 223219e-10,
				y: .632185,
				width: 64.7741,
				height: 48.9037,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.91283,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_3413_281"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.14072 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.67372 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3413_281"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.478207,
						dy: .71731
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.19552 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_3413_281",
						result: "effect2_dropShadow_3413_281"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.19552,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect3_dropShadow_3413_281"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .119552,
						dy: 1.43462
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.79328 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_3413_281",
						result: "effect3_dropShadow_3413_281"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_3413_281",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_i_3413_281",
				x: 7.21448,
				y: 7.53015,
				width: 33.5177,
				height: 36.096,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2.57826,
						dy: 5.15651
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.57826 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_3413_281"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_3413_281",
				x1: 38.8689,
				y1: 5.6439,
				x2: 6.49953,
				y2: 40.3558,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C026D3" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4F49BA"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_3413_281",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 6.6842,
					y: 8.07959,
					width: 30.9391,
					height: 30.9391,
					rx: 15.4695,
					transform: "rotate(-2 6.6842 8.07959)",
					fill: "white"
				})
			})
		] })
	]
});
export default SvgBookCoverBirdieDark;
